import { combineReducers } from 'redux'
import detail from './detail'

export default combineReducers({
  detail,
})
